/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersSummaryResult } from '../../models/get-orders-summary-result';

export interface GetOrderssummary$Params {
  RestaurantId?: number;
  StartDate?: string;
  EndDate?: string;
}

export function getOrderssummary(
  http: HttpClient,
  rootUrl: string,
  params?: GetOrderssummary$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetOrdersSummaryResult>> {
  const rb = new RequestBuilder(rootUrl, getOrderssummary.PATH, 'get');
  if (params) {
    rb.query('RestaurantId', params.RestaurantId, {});
    rb.query('StartDate', params.StartDate, {});
    rb.query('EndDate', params.EndDate, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrdersSummaryResult>;
    }),
  );
}

getOrderssummary.PATH = '/Orders/ordersSummary';
